{
    "Domain": "Domínio:",
    "EmailServerConnectivity": "Conectividade do servidor de e-mail",
    "ServerIpAddress": "Endereço IP do servidor:",
    "TcpPort": "Porta TCP:",
    "CommunicationActive": "Comunicação Ativa:",
    "FromAddressEmail": "Do Endereço (E-mail):",
    "FromAddressName": "De Endereço (Nome):",
    "CompanyName": "Nome da empresa:",
    "UseAuthentication": "Usar autenticação:",
    "AuthenticationSettings": "Definições de autenticação",
    "DomainProfile_ButtonHelpLabel": "Ajuda?",
    "DomainProfile_ButtonSubmitLabel": "OK",
    "DomainProfile_ButtonCancelLabel": "Cancelar",
    "DomainProfile_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "DomainProfile_PromptConfirm": "sim",
    "DomainProfile_PromptCancel": "Cancelar",
    "DomainProfile_Username": "Nome do utilizador:",
    "DomainProfile_Password": "Palavra-passe:",
    "DomainProfile_PasswordPlaceholder": "••••••",
    "NAME": "DomainProfile",
    "CustomDownloadLinks": "Ligações de transferências personalizadas",
    "MSTeamsAppDownloadLinkURLName": "URL para descarregar a aplicação MS Teams:",
    "CXIClientDownloadLinkWindowsUrlName": "URL do cliente CXI (Windows):",
    "CXIClientDownloadLinkMacUrlName": "URL do cliente CXI (Mac):",
    "SearchAndCallDownloadLinkURLName": "URL de pesquisa e chamada:",
    "AccessCodes": "Códigos de acesso",
    "CXIAccessCode": "Código de acesso CXI:"
}